import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import { apiURL } from "../api/index";

function Orders(props) {
  const Navigate = useNavigate();
  const [loggedInUser, setLoggedInUser] = useState("");
  const [activeTab, setActiveTab] = useState("All");

  // eslint-disable-next-line react-hooks/exhaustive-deps
  useEffect(() => {
    const LoadPage = async () => {
      try {
        const res = await fetch(`${apiURL}/check`, {
          method: "GET",
          headers: {
            "Content-Type": "application/json",
          },
          credentials: "include",
        });

        const data = await res.json();
        setLoggedInUser(data.name);
      } catch (error) {
        Navigate("/login");
      }
    };
    LoadPage();
    // filterByLoggedInUser();
  }, [Navigate]);

  // Filter bookings based on active tab
  const filteredOrders = props.orders.filter((order) => {
    if (activeTab === "All") return true && loggedInUser === order.buyer;
    if (activeTab === "Pending")
      return order.status === "Pending" && loggedInUser === order.buyer;
    if (activeTab === "Delivered")
      return order.status === "Delivered" && loggedInUser === order.buyer;

    return false;
  });

  return (
    <div className="font-primary">
      <div className="mt-6 flex justify-between w-[88%] mx-auto items-center">
        <h2 className="text-2xl font-semibold text-primary">All Orders</h2>
        <div className="flex">
          <button
            onClick={() => setActiveTab("All")}
            className={`flex-1 text-white px-3 m-1 py-2 rounded-full ${
              activeTab === "All" ? "bg-primary" : "bg-gray-300"
            }`}
          >
            ALL
          </button>
          <button
            className={`flex-1 text-white px-3 m-1 py-2 rounded-full ${
              activeTab === "Pending" ? "bg-red-600" : "bg-gray-300"
            }`}
            onClick={() => setActiveTab("Pending")}
          >
            Pending
          </button>
          <button
            className={`flex-1 text-white px-3 m-1 py-2 rounded-full ${
              activeTab === "Delivered" ? "bg-green-600" : "bg-gray-300"
            }`}
            onClick={() => setActiveTab("Delivered")}
          >
            Delivered
          </button>
        </div>
      </div>
      {/* table of bookings including all, cancelled and success */}
      <div className="flex justify-between items-center text-gray-600">
        <div className="w-[88%] mx-auto">
          <table className="w-full">
            <thead>
              <tr className="bg-background text-gray-800">
                <th className="py-2 px-4 font-semibold">Buyer</th>
                <th className="py-2 px-4 font-semibold">Email</th>
                <th className="py-2 px-4 font-semibold">Items</th>
                <th className="py-2 px-4 font-semibold">Total</th>
                <th className="py-2 px-4 font-semibold">Address</th>
                <th className="py-2 px-4 font-semibold">Status</th>
                <th className="py-2 px-4 font-semibold">Delivery</th>
              </tr>
            </thead>
            <tbody className="dark:bg-slate-500 dark:text-white">
              {filteredOrders.map((order) => {
                return (
                  <tr className="text-center" key={order._id}>
                    <td className="py-2 px-4">{order.buyer}</td>
                    <td className="py-2 px-4">{order.email}</td>
                    <td className="py-2 px-4">{order.items}</td>
                    <td className="py-2 px-4">{order.total}</td>
                    <td className="py-2 px-4">{order.address}</td>
                    <td>
                      <button className="cursor-default bg-gray-700 text-white py-1 px-4 rounded-sm">
                        Paid
                      </button>
                    </td>
                    <td>
                      {order.status === "Delivered" ? (
                        <button className="bg-green-500 px-2 py-1 text-white">
                          Completed
                        </button>
                      ) : (
                        <button className="bg-red-600 px-2 py-1 text-white">
                          Pending
                        </button>
                      )}
                    </td>
                  </tr>
                );
              })}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}

export default Orders;
